/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassAttendanceRef,
  JpClassAttendanceRefOptional,
  JpClassAttendanceRefMetaI,
  JpClassAttendanceRefTrackedI,
} from "./jp-class-attendance-ref";
import {
  JpClassAttendanceRefTracked,
  JpClassAttendanceRefMeta,
} from "./jp-class-attendance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassInstanceRef,
  JpClassInstanceRefOptional,
  JpClassInstanceRefMetaI,
  JpClassInstanceRefTrackedI,
} from "./jp-class-instance-ref";
import {
  JpClassInstanceRefTracked,
  JpClassInstanceRefMeta,
} from "./jp-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionRef,
  JpClassSectionRefOptional,
  JpClassSectionRefMetaI,
  JpClassSectionRefTrackedI,
} from "./jp-class-section-ref";
import {
  JpClassSectionRefTracked,
  JpClassSectionRefMeta,
} from "./jp-class-section-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSignupFull,
  JpClassSignupFullOptional,
  JpClassSignupFullMetaI,
  JpClassSignupFullTrackedI,
} from "./jp-class-signup-full";
import {
  JpClassSignupFullTracked,
  JpClassSignupFullMeta,
} from "./jp-class-signup-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassWlResultFull,
  JpClassWlResultFullOptional,
  JpClassWlResultFullMetaI,
  JpClassWlResultFullTrackedI,
} from "./jp-class-wl-result-full";
import {
  JpClassWlResultFullTracked,
  JpClassWlResultFullMeta,
} from "./jp-class-wl-result-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipRef,
  MembershipRefOptional,
  MembershipRefMetaI,
  MembershipRefTrackedI,
} from "./membership-ref";
import { MembershipRefTracked, MembershipRefMeta } from "./membership-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassStaggerRef,
  UnifiedClassStaggerRefOptional,
  UnifiedClassStaggerRefMetaI,
  UnifiedClassStaggerRefTrackedI,
} from "./unified-class-stagger-ref";
import {
  UnifiedClassStaggerRefTracked,
  UnifiedClassStaggerRefMeta,
} from "./unified-class-stagger-ref";

/**
 *
 * @export
 * @interface CreateJpClassSignupDTO
 */
export interface CreateJpClassSignupDTOOptional extends JpClassSignupFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof CreateJpClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof CreateJpClassSignupDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof CreateJpClassSignupDTO
   */
  instanceId?: JpClassInstanceRefOptional;
  /**
   *
   * @type {JpClassWlResultFull}
   * @memberof CreateJpClassSignupDTO
   */
  wlResult?: JpClassWlResultFullOptional;
  /**
   *
   * @type {Array<JpClassAttendanceRef>}
   * @memberof CreateJpClassSignupDTO
   */
  attendance?: JpClassAttendanceRefOptional[];
  /**
   *
   * @type {MembershipRef}
   * @memberof CreateJpClassSignupDTO
   */
  membershipUsed?: MembershipRefOptional;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof CreateJpClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRefOptional;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdBy?: string;
  /**
   *
   * @type {JpClassSectionRef}
   * @memberof CreateJpClassSignupDTO
   */
  sectionId?: JpClassSectionRefOptional;
}

export interface CreateJpClassSignupDTO
  extends CreateJpClassSignupDTOOptional, JpClassSignupFull {
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof CreateJpClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof CreateJpClassSignupDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof CreateJpClassSignupDTO
   */
  instanceId: JpClassInstanceRef;
  /**
   *
   * @type {JpClassWlResultFull}
   * @memberof CreateJpClassSignupDTO
   */
  wlResult?: JpClassWlResultFull;
  /**
   *
   * @type {Array<JpClassAttendanceRef>}
   * @memberof CreateJpClassSignupDTO
   */
  attendance?: JpClassAttendanceRef[];
  /**
   *
   * @type {MembershipRef}
   * @memberof CreateJpClassSignupDTO
   */
  membershipUsed?: MembershipRef;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof CreateJpClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRef;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdBy?: string;
  /**
   *
   * @type {JpClassSectionRef}
   * @memberof CreateJpClassSignupDTO
   */
  sectionId?: JpClassSectionRef;
}

export interface CreateJpClassSignupDTOTrackedI extends JpClassSignupFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateJpClassSignupDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupDatetime?: Date;
  signupDatetimeIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof CreateJpClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  signupNote?: string;
  signupNoteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateJpClassSignupDTO
   */
  sequence?: number;
  sequenceIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof CreateJpClassSignupDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof CreateJpClassSignupDTO
   */
  instanceId?: JpClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {JpClassWlResultFull}
   * @memberof CreateJpClassSignupDTO
   */
  wlResult?: JpClassWlResultFullTrackedI;
  wlResultIsSet: boolean;
  /**
   *
   * @type {Array<JpClassAttendanceRef>}
   * @memberof CreateJpClassSignupDTO
   */
  attendance?: JpClassAttendanceRefTrackedI[];
  attendanceIsSet: boolean;
  /**
   *
   * @type {MembershipRef}
   * @memberof CreateJpClassSignupDTO
   */
  membershipUsed?: MembershipRefTrackedI;
  membershipUsedIsSet: boolean;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof CreateJpClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRefTrackedI;
  staggerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateJpClassSignupDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {JpClassSectionRef}
   * @memberof CreateJpClassSignupDTO
   */
  sectionId?: JpClassSectionRefTrackedI;
  sectionIdIsSet: boolean;
}

transformDatesMap.set(
  "CreateJpClassSignupDTO",
  function (model: CreateJpClassSignupDTO) {
    if (typeof model.signupDatetime == "string")
      model.signupDatetime = new Date(model.signupDatetime);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesinstanceId =
      transformDatesMap.get("JpClassInstanceRef");
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDateswlResult = transformDatesMap.get("JpClassWlResultFull");
    if (transformDateswlResult && model.wlResult) {
      transformDateswlResult(model.wlResult);
    }
    const transformDatesattendance = transformDatesMap.get(
      "JpClassAttendanceRef",
    );
    if (transformDatesattendance) {
      model.attendance?.forEach((sub) => {
        transformDatesattendance(sub);
      });
    }
    const transformDatesmembershipUsed = transformDatesMap.get("MembershipRef");
    if (transformDatesmembershipUsed && model.membershipUsed) {
      transformDatesmembershipUsed(model.membershipUsed);
    }
    const transformDatesstaggerId = transformDatesMap.get(
      "UnifiedClassStaggerRef",
    );
    if (transformDatesstaggerId && model.staggerId) {
      transformDatesstaggerId(model.staggerId);
    }
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
    const transformDatessectionId = transformDatesMap.get("JpClassSectionRef");
    if (transformDatessectionId && model.sectionId) {
      transformDatessectionId(model.sectionId);
    }
  },
);

export type CreateJpClassSignupDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  signupDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  signupNote: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sequence: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<JpClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<JpClassWlResultFullMetaI>;
  //isDate: false
  //isDatetime: false
  attendance: PropertyMeta<JpClassAttendanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  membershipUsed: PropertyMeta<MembershipRefMetaI>;
  //isDate: false
  //isDatetime: false
  staggerId: PropertyMeta<UnifiedClassStaggerRefMetaI>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sectionId: PropertyMeta<JpClassSectionRefMetaI>;
}>;

export var CreateJpClassSignupDTOMeta: CreateJpClassSignupDTOMetaI =
  {} as CreateJpClassSignupDTOMetaI;
CreateJpClassSignupDTOMeta = typeMeta("CreateJpClassSignupDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupDatetime: propertyMeta(
    "signupDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  signupNote: propertyMeta(
    "signupNote",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sequence: propertyMeta("sequence", false, false, false, MetaTypesBase.number),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    false,
    JpClassInstanceRefMeta,
  ),
  wlResult: propertyMeta(
    "wlResult",
    false,
    false,
    false,
    JpClassWlResultFullMeta,
  ),
  attendance: propertyMeta(
    "attendance",
    true,
    false,
    false,
    JpClassAttendanceRefMeta,
  ),
  membershipUsed: propertyMeta(
    "membershipUsed",
    false,
    false,
    false,
    MembershipRefMeta,
  ),
  staggerId: propertyMeta(
    "staggerId",
    false,
    false,
    false,
    UnifiedClassStaggerRefMeta,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sectionId: propertyMeta(
    "sectionId",
    false,
    false,
    false,
    JpClassSectionRefMeta,
  ),
});

const metaI = CreateJpClassSignupDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([JpClassSignupFullMeta]);
  metaI.isDeleted.inheritedFrom = JpClassSignupFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = JpClassSignupFullMeta.isNew;
  metaI.assignId.inheritedFrom = JpClassSignupFullMeta.assignId;
  metaI.price.inheritedFrom = JpClassSignupFullMeta.price;
  metaI.signupDatetime.inheritedFrom = JpClassSignupFullMeta.signupDatetime;
  metaI.signupType.inheritedFrom = JpClassSignupFullMeta.signupType;
  metaI.signupNote.inheritedFrom = JpClassSignupFullMeta.signupNote;
  metaI.sequence.inheritedFrom = JpClassSignupFullMeta.sequence;
  metaI.personId.inheritedFrom = JpClassSignupFullMeta.personId;
  metaI.instanceId.inheritedFrom = JpClassSignupFullMeta.instanceId;
  metaI.wlResult.inheritedFrom = JpClassSignupFullMeta.wlResult;
  metaI.attendance.inheritedFrom = JpClassSignupFullMeta.attendance;
  metaI.membershipUsed.inheritedFrom = JpClassSignupFullMeta.membershipUsed;
  metaI.staggerId.inheritedFrom = JpClassSignupFullMeta.staggerId;
  metaI.updatedOn.inheritedFrom = JpClassSignupFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = JpClassSignupFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = JpClassSignupFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = JpClassSignupFullMeta.createdBy;
  metaI.sectionId.inheritedFrom = JpClassSignupFullMeta.sectionId;
});

export class CreateJpClassSignupDTOTracked
  extends JpClassSignupFullTracked
  implements CreateJpClassSignupDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupDatetime__I?: Date = undefined;
  signupDatetimeIsSet: boolean = false;
  set signupDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.signupDatetime__I = v;
      this.signupDatetimeIsSet = true;
    } else {
      this.signupDatetime__I = v || undefined;
      this.signupDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupDatetime() {
    return this.signupDatetime__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  signupNote__I?: string = undefined;
  signupNoteIsSet: boolean = false;
  set signupNote(v: undefined | string) {
    if (v !== undefined) {
      this.signupNote__I = v;
      this.signupNoteIsSet = true;
    } else {
      this.signupNote__I = v || undefined;
      this.signupNoteIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupNote() {
    return this.signupNote__I;
  }
  sequence__I?: number = undefined;
  sequenceIsSet: boolean = false;
  set sequence(v: undefined | number) {
    if (v !== undefined) {
      this.sequence__I = v;
      this.sequenceIsSet = true;
    } else {
      this.sequence__I = v || undefined;
      this.sequenceIsSet = false;
    }
    this.changeTracker = true;
  }
  get sequence() {
    return this.sequence__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  instanceId__I?: JpClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | JpClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  wlResult__I?: JpClassWlResultFullTracked = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | JpClassWlResultFullTracked) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  attendance__I?: JpClassAttendanceRefTracked[] = undefined;
  attendanceIsSet: boolean = false;
  set attendance(v: undefined | JpClassAttendanceRefTracked[]) {
    if (v !== undefined) {
      this.attendance__I = v;
      this.attendanceIsSet = true;
    } else {
      this.attendance__I = v || undefined;
      this.attendanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get attendance() {
    return this.attendance__I;
  }
  membershipUsed__I?: MembershipRefTracked = undefined;
  membershipUsedIsSet: boolean = false;
  set membershipUsed(v: undefined | MembershipRefTracked) {
    if (v !== undefined) {
      this.membershipUsed__I = v;
      this.membershipUsedIsSet = true;
    } else {
      this.membershipUsed__I = v || undefined;
      this.membershipUsedIsSet = false;
    }
    this.changeTracker = true;
  }
  get membershipUsed() {
    return this.membershipUsed__I;
  }
  staggerId__I?: UnifiedClassStaggerRefTracked = undefined;
  staggerIdIsSet: boolean = false;
  set staggerId(v: undefined | UnifiedClassStaggerRefTracked) {
    if (v !== undefined) {
      this.staggerId__I = v;
      this.staggerIdIsSet = true;
    } else {
      this.staggerId__I = v || undefined;
      this.staggerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get staggerId() {
    return this.staggerId__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  sectionId__I?: JpClassSectionRefTracked = undefined;
  sectionIdIsSet: boolean = false;
  set sectionId(v: undefined | JpClassSectionRefTracked) {
    if (v !== undefined) {
      this.sectionId__I = v;
      this.sectionIdIsSet = true;
    } else {
      this.sectionId__I = v || undefined;
      this.sectionIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get sectionId() {
    return this.sectionId__I;
  }
  constructor(
    config?: CreateJpClassSignupDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.instanceId?.setIds();

    this.wlResult?.setIds();

    this.attendance?.forEach((a) => a.setIds());
    this.membershipUsed?.setIds();

    this.staggerId?.setIds();

    this.sectionId?.setIds();
  }
  assignFrom(
    config: CreateJpClassSignupDTOOptional,
    options?: AssignOptions,
  ): CreateJpClassSignupDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.signupDatetime &&
      this.signupDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.signupDatetime = config.signupDatetime;
      if (optionsRequired.unassign) this.signupDatetimeIsSet = false;
      else this.signupDatetimeIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (
      config.signupNote &&
      this.signupNoteApplyFilter(optionsRequired.filter)
    ) {
      this.signupNote = config.signupNote;
      if (optionsRequired.unassign) this.signupNoteIsSet = false;
      else this.signupNoteIsSet = true;
    }
    if (config.sequence && this.sequenceApplyFilter(optionsRequired.filter)) {
      this.sequence = config.sequence;
      if (optionsRequired.unassign) this.sequenceIsSet = false;
      else this.sequenceIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new JpClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = new JpClassWlResultFullTracked(config.wlResult, options);
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (
      config.attendance &&
      this.attendanceApplyFilter(optionsRequired.filter)
    ) {
      this.attendance = config.attendance?.map(
        (a) => new JpClassAttendanceRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.attendanceIsSet = false;
      else this.attendanceIsSet = true;
    }
    if (
      config.membershipUsed &&
      this.membershipUsedApplyFilter(optionsRequired.filter)
    ) {
      this.membershipUsed = new MembershipRefTracked(
        config.membershipUsed,
        options,
      );
      if (optionsRequired.unassign) this.membershipUsedIsSet = false;
      else this.membershipUsedIsSet = true;
    }
    if (config.staggerId && this.staggerIdApplyFilter(optionsRequired.filter)) {
      this.staggerId = new UnifiedClassStaggerRefTracked(
        config.staggerId,
        options,
      );
      if (optionsRequired.unassign) this.staggerIdIsSet = false;
      else this.staggerIdIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.sectionId && this.sectionIdApplyFilter(optionsRequired.filter)) {
      this.sectionId = new JpClassSectionRefTracked(config.sectionId, options);
      if (optionsRequired.unassign) this.sectionIdIsSet = false;
      else this.sectionIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CreateJpClassSignupDTOTrackedI {
    const cloned = {} as CreateJpClassSignupDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupDatetimeIsSetDeep() &&
      this.signupDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupDatetimeIsSet = true;
      cloned.signupDatetime = this.signupDatetime;
    } else {
      //cloned.signupDatetimeIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.signupNoteIsSetDeep() &&
      this.signupNoteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupNoteIsSet = true;
      cloned.signupNote = this.signupNote;
    } else {
      //cloned.signupNoteIsSet = false
    }
    if (
      this.sequenceIsSetDeep() &&
      this.sequenceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sequenceIsSet = true;
      cloned.sequence = this.sequence;
    } else {
      //cloned.sequenceIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult?.removeUnset(filter);
    } else {
      //cloned.wlResultIsSet = false
    }
    if (
      this.attendanceIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.attendanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendanceIsSet = true;
      cloned.attendance = this.attendance
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.attendanceIsSet = false
    }
    if (
      this.membershipUsedIsSetDeep() &&
      this.membershipUsedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipUsedIsSet = true;
      cloned.membershipUsed = this.membershipUsed?.removeUnset(filter);
    } else {
      //cloned.membershipUsedIsSet = false
    }
    if (
      this.staggerIdIsSetDeep() &&
      this.staggerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.staggerIdIsSet = true;
      cloned.staggerId = this.staggerId?.removeUnset(filter);
    } else {
      //cloned.staggerIdIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.sectionIdIsSetDeep() &&
      this.sectionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionIdIsSet = true;
      cloned.sectionId = this.sectionId?.removeUnset(filter);
    } else {
      //cloned.sectionIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CreateJpClassSignupDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupDatetimeApplyFilter(filter))
      this.signupDatetimeIsSet = false;

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.signupNoteApplyFilter(filter)) this.signupNoteIsSet = false;

    if (!this.sequenceApplyFilter(filter)) this.sequenceIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;
    this.wlResult?.unassignAll(filter);

    if (!this.attendanceApplyFilter(filter)) this.attendanceIsSet = false;

    this.attendance?.forEach((a) => a.unassignAll(filter));
    if (!this.membershipUsedApplyFilter(filter))
      this.membershipUsedIsSet = false;
    this.membershipUsed?.unassignAll(filter);

    if (!this.staggerIdApplyFilter(filter)) this.staggerIdIsSet = false;
    this.staggerId?.unassignAll(filter);

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.sectionIdApplyFilter(filter)) this.sectionIdIsSet = false;
    this.sectionId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.isDeleted,
      CreateJpClassSignupDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.isNew,
      CreateJpClassSignupDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.assignId,
      CreateJpClassSignupDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.price,
      CreateJpClassSignupDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.signupDatetime,
      CreateJpClassSignupDTOMeta,
      this.signupDatetime,
      this,
    );
  }
  signupDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupDatetimeIsSet && this.signupDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.signupType,
      CreateJpClassSignupDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  signupNoteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.signupNote,
      CreateJpClassSignupDTOMeta,
      this.signupNote,
      this,
    );
  }
  signupNoteIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupNoteIsSet && this.signupNoteApplyFilter(filter)) return true;

    return false;
  }
  sequenceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.sequence,
      CreateJpClassSignupDTOMeta,
      this.sequence,
      this,
    );
  }
  sequenceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sequenceIsSet && this.sequenceApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.personId,
      CreateJpClassSignupDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.instanceId,
      CreateJpClassSignupDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.wlResult,
      CreateJpClassSignupDTOMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;
    return this.wlResult?.anySet(filter) == true;

    return false;
  }
  attendanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.attendance,
      CreateJpClassSignupDTOMeta,
      this.attendance,
      this,
    );
  }
  attendanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendanceIsSet && this.attendanceApplyFilter(filter)) return true;

    return this.attendance?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  membershipUsedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.membershipUsed,
      CreateJpClassSignupDTOMeta,
      this.membershipUsed,
      this,
    );
  }
  membershipUsedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipUsedIsSet && this.membershipUsedApplyFilter(filter))
      return true;
    return this.membershipUsed?.anySet(filter) == true;

    return false;
  }
  staggerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.staggerId,
      CreateJpClassSignupDTOMeta,
      this.staggerId,
      this,
    );
  }
  staggerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.staggerIdIsSet && this.staggerIdApplyFilter(filter)) return true;
    return this.staggerId?.anySet(filter) == true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.updatedOn,
      CreateJpClassSignupDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.updatedBy,
      CreateJpClassSignupDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.createdOn,
      CreateJpClassSignupDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.createdBy,
      CreateJpClassSignupDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  sectionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateJpClassSignupDTOMeta.sectionId,
      CreateJpClassSignupDTOMeta,
      this.sectionId,
      this,
    );
  }
  sectionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionIdIsSet && this.sectionIdApplyFilter(filter)) return true;
    return this.sectionId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupDatetimeIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.signupNoteIsSetDeep(filter)) return true;
    if (this.sequenceIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    if (this.attendanceIsSetDeep(filter)) return true;
    if (this.membershipUsedIsSetDeep(filter)) return true;
    if (this.staggerIdIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.sectionIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
